export default "images/direction.png";